angular.module("vgresiduos").controller("MasterPermissionGroupListCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `master/perfis-acesso`);
		};
	}
]);
